/**
 * Company Price tab API — daily OHLCV from priceHistory (not Global Markets).
 */
import { api } from '../auth/apiClient';

const unwrap = (res) => (res && typeof res === 'object' && 'data' in res ? res.data : res);

/** GET /api/finlytics/companies/{companyId}/price/history?period=1Y */
export async function getCompanyPriceHistory(companyId, period = '1Y', options = {}) {
    const ticker = encodeURIComponent(String(companyId || '').toUpperCase());
    const params = new URLSearchParams();
    params.set('period', period);
    return api.get(`/finlytics/companies/${ticker}/price/history?${params.toString()}`, {
        timeout: 120000,
        signal: options?.signal,
    });
}

/** POST /api/finlytics/companies/{companyId}/price/refresh */
export async function refreshCompanyPrice(companyId, options = {}) {
    const ticker = encodeURIComponent(String(companyId || '').toUpperCase());
    const params = new URLSearchParams();
    if (options?.force) params.set('force', 'true');
    if (options?.period) params.set('period', options.period);
    const qs = params.toString();
    const url = `/finlytics/companies/${ticker}/price/refresh${qs ? `?${qs}` : ''}`;
    return api.post(url, {}, { timeout: 120000 });
}

export { unwrap as unwrapCompanyPriceResponse };
